/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A pricing variable of the quote in a validation snapshot.
 * @export
 * @interface DevisPhotoVariable
 */
export interface DevisPhotoVariable {
    /**
     * 
     * @type {string}
     * @memberof DevisPhotoVariable
     */
    variableId: string;
    /**
     * 
     * @type {string}
     * @memberof DevisPhotoVariable
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisPhotoVariable
     */
    libelle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisPhotoVariable
     */
    valeur: number;
}

/**
 * Check if a given object implements the DevisPhotoVariable interface.
 */
export function instanceOfDevisPhotoVariable(value: object): value is DevisPhotoVariable {
    if (!('variableId' in value) || value['variableId'] === undefined) return false;
    if (!('valeur' in value) || value['valeur'] === undefined) return false;
    return true;
}

export function DevisPhotoVariableFromJSON(json: any): DevisPhotoVariable {
    return DevisPhotoVariableFromJSONTyped(json, false);
}

export function DevisPhotoVariableFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevisPhotoVariable {
    if (json == null) {
        return json;
    }
    return {
        
        'variableId': json['variableId'],
        'code': json['code'] == null ? undefined : json['code'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'valeur': json['valeur'],
    };
}

export function DevisPhotoVariableToJSON(json: any): DevisPhotoVariable {
    return DevisPhotoVariableToJSONTyped(json, false);
}

export function DevisPhotoVariableToJSONTyped(value?: DevisPhotoVariable | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variableId': value['variableId'],
        'code': value['code'],
        'libelle': value['libelle'],
        'valeur': value['valeur'],
    };
}

